import { Select,Form } from 'antd'
import React, { useEffect, useState } from 'react'
import { useGwGoodsTypeSubListQuery } from '../../store/ReactWebSiteApi';

function SonTypeSelect(props) {
    const [list,setList] = useState();
        const {data,isSuccess} = useGwGoodsTypeSubListQuery({eowgt_id:props.eowgt_id})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                
                const newArr = data.Result.map((item) => {
                    const {eowgts_id,eowgts_name }=item;
                    return item = {value:eowgts_id,label:eowgts_name }
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
            >
                <Select 
                    options={list} 
                    onChange={(_,f) => {
                        console.log(f);
                        props.onChange(f.value,f.label,)
                    }}
                    defaultValue={props.defaultId}
                    placeholder={props.defaultId}
                    style={props.style}
                />
            </Form.Item>
        </>
    )
}

export default SonTypeSelect